import { createSelector } from 'reselect'

import { AppState } from '@/ducks/app/slices/app.slice'

const selectApp = (state: { app: AppState }) => state.app

export const selectIsAppInitialized = createSelector(
  selectApp,
  app => app.isInitialized
)

export const selectBootStatus = createSelector(selectApp, app => app.bootStatus)

export const selectAppSettings = createSelector(selectApp, app => app.settings)

export const selectIsSidebarOpen = createSelector(
  selectApp,
  app => app.isSidebarOpen
)

export const selectFlags = createSelector(selectApp, app => app.flags)

export const selectFlagsReady = createSelector(selectApp, app => app.flagsReady)

const STORE_AUTH_V4_USE_LMD_CORE_FLAG = 'store-auth-v4-use-lmd-core'
const STORE_AUTH_V4_USE_LMD_CORE_FLAG_UNDERSCORE = 'store_auth_v4_use_lmd_core'

export const selectIsStoreAuthV4UseLmdCoreEnabled = createSelector(
  selectFlags,
  flags =>
    Boolean(
      flags?.[STORE_AUTH_V4_USE_LMD_CORE_FLAG] ||
        flags?.[STORE_AUTH_V4_USE_LMD_CORE_FLAG_UNDERSCORE]
    )
)

export const selectNotificationAppId = createSelector(
  selectApp,
  app => app.notificationAppId
)

export const selectPendingOrdersIds = createSelector(
  selectApp,
  app => app.pendingOrderIds
)
export const selectHasUserInteracted = createSelector(
  selectApp,
  app => app.hasUserInteracted
)
